import React, { useState } from 'react';
import { TrendingUp, Users, FileText, Receipt } from 'lucide-react';
import DrillingDataTable from './Admin/Tables/DrillingDataTable';
import VehiclesTable from './Admin/Tables/VehicalTable';
import BillsTable from './Admin/Tables/BillsTable';
import ProductsManager from './Admin/Tables/ProductsManager';
import SupplierManagement from './Admin/Tables/SupplierManagement';

const ProjectTabs = () => {
    const [activeTab, setActiveTab] = useState('bills');

    const tabs = [
        { id: 'bills', label: 'Bills', icon: Receipt },

        { id: 'drilling', label: 'Drilling Data', icon: TrendingUp },
        { id: 'vehicles', label: 'Vehicles', icon: FileText },
        { id: 'products', label: 'Products', icon: FileText },
        { id: 'suppliers', label: 'Suppliers', icon: FileText },
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white shadow-sm border-b">
                <div className=" mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center">
                            <div className="text-2xl mr-3">🚜</div>
                            <h1 className="text-xl font-semibold text-gray-900">
                                Project & Vehicle Management
                            </h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="bg-white shadow-sm">
                <div className=" mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex space-x-8">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <tab.icon className="h-5 w-5" />
                                <span>{tab.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="mx-auto px-4 sm:px-6 lg:px-6 py-6">
                {activeTab === 'drilling' && <DrillingDataTable />}
                {activeTab === 'vehicles' && <VehiclesTable />}
                {activeTab === 'bills' && <BillsTable />}
                {activeTab === 'suppliers' && <SupplierManagement />}
                {activeTab === 'products' && <ProductsManager />}
            </div>
        </div>
    );
};

export default ProjectTabs;